var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { Box, Collapse, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
var menuItems = [
    {
        text: 'Portal de Credenciamento - Início',
        icon: _jsx(HomeIcon, {}),
        route: '/',
    },
    {
        text: 'Gestão de Solicitações',
        icon: _jsx(NoteAddIcon, {}),
        submenus: [
            { text: 'Acompanhar Solicitação', route: '/processo' },
            { text: 'Novo Processo', route: '/processo/novo' },
            { text: 'Solicitar Renovação', route: '/processo/renovacao' },
            { text: 'Editar Dados da Empresa', route: '/processo-edicao' },
        ],
    },
];
export var SidebarMenu = function () {
    var _a = useState(false), isDrawerOpen = _a[0], setIsDrawerOpen = _a[1];
    var _b = useState({}), openSubmenus = _b[0], setOpenSubmenus = _b[1];
    var navigate = useNavigate();
    var handleToggleSubmenu = function (text) {
        setOpenSubmenus(function (prevOpenSubmenus) {
            var _a;
            return (__assign(__assign({}, prevOpenSubmenus), (_a = {}, _a[text] = !prevOpenSubmenus[text], _a)));
        });
    };
    var toggleDrawer = function (open) { return function (event) {
        if (event.type === 'keydown' &&
            event.key === 'Tab') {
            return;
        }
        setIsDrawerOpen(open);
    }; };
    var handleNavigation = function (route) {
        navigate(route);
        setIsDrawerOpen(false);
    };
    return (_jsxs(Box, { children: [_jsx(IconButton, { onClick: toggleDrawer(true), sx: { color: 'white' }, children: _jsx(MenuIcon, {}) }), _jsx(Drawer, { anchor: "right", open: isDrawerOpen, onClose: toggleDrawer(false), children: _jsxs(Box, { sx: { width: 350 }, role: "presentation", children: [_jsx(Typography, { variant: "h6", sx: { m: 2 }, children: "Servi\u00E7os" }), _jsx(List, { children: menuItems.map(function (item, index) { return (_jsx(React.Fragment, { children: item.submenus ? (_jsxs(_Fragment, { children: [_jsx(ListItem, { children: _jsxs(ListItemButton, { onClick: function () { return handleToggleSubmenu(item.text); }, children: [_jsx(ListItemIcon, { children: item.icon }), _jsx(ListItemText, { primary: item.text }), openSubmenus[item.text] ? (_jsx(ExpandLess, {})) : (_jsx(ExpandMore, {}))] }) }), _jsx(Collapse, { in: openSubmenus[item.text], timeout: "auto", unmountOnExit: true, children: _jsx(List, { component: "div", disablePadding: true, children: item.submenus.map(function (submenu, subIndex) { return (_jsx(ListItem, { sx: { pl: 4 }, children: _jsx(ListItemButton, { onClick: function () { return handleNavigation(submenu.route); }, children: _jsx(ListItemText, { primary: submenu.text }) }) }, subIndex)); }) }) })] })) : (_jsx(ListItem, { children: _jsxs(ListItemButton, { onClick: function () { return handleNavigation(item.route); }, children: [_jsx(ListItemIcon, { children: item.icon }), _jsx(ListItemText, { primary: item.text })] }) })) }, index)); }) })] }) })] }));
};
